import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  class: "joboffers",
  id: "joboffers"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row row-flex" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-6 box box-left" }, [
  /*#__PURE__*/_createVNode("h2", null, "We want you!"),
  /*#__PURE__*/_createVNode("p", null, "Come and join our team!")
], -1)
const _hoisted_5 = { class: "col-12 col-sm-6 box box-right" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Send us your CV: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JobOfferModal = _resolveComponent("JobOfferModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.jobOffers, (item, key) => {
              return (_openBlock(), _createBlock("h4", { key: key }, [
                _createVNode("a", {
                  "data-pid": item.pid,
                  onClick: ($event: any) => (_ctx.jobClicked(item.pid)),
                  class: "anchor-pointer"
                }, [
                  _createTextVNode(_toDisplayString(item.title), 1),
                  _hoisted_7,
                  _createVNode("small", null, _toDisplayString(item.place), 1)
                ], 8, ["data-pid", "onClick"])
              ]))
            }), 128))
          ]),
          _hoisted_8,
          _createVNode("strong", null, [
            _hoisted_9,
            _createVNode("a", {
              class: "anchor-pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emailClicked())),
              innerHTML: _ctx.mailto
            }, null, 8, ["innerHTML"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_JobOfferModal, { item: _ctx.modalItem }, null, 8, ["item"])
  ]))
}